import React, { useEffect, useState } from 'react';
import html2canvas from 'html2canvas';
import { FaShareAlt, FaDownload } from 'react-icons/fa';
import { fetchAyahArAlafasy } from "./utils/quranApi";

const RandomVerse = () => {
  const [randomVerseData, setRandomVerseData] = useState(null);
  const [loading, setLoading] = useState(true);

  function randomIntFromInterval(min, max) {
    return Math.round((min - 0.5) + Math.random() * (max - min + 1));
  }

  const fetchRandomVerse = async () => {
    setLoading(true);
    try {
      const randomInt = randomIntFromInterval(1, 6236);
      const data = await fetchAyahArAlafasy(randomInt);
      setRandomVerseData(data);
    } catch (error) {
      console.error('Error fetching data:', error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRandomVerse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const h1Element = document.querySelector('h1');
    if (h1Element) {
      h1Element.classList.add('loaded');
    }
  }, [randomVerseData]);

  const handleShare = () => {
    if (navigator.share && randomVerseData) {
      navigator.share({
        title: 'Quran Verse',
        text: `${randomVerseData.data.text}\n\n${randomVerseData.data.surah.name} — آية ${randomVerseData.data.numberInSurah}`
      }).catch((error) => console.error('Sharing failed:', error));
    } else {
      navigator.clipboard.writeText(`${randomVerseData.data.text}\n\n${randomVerseData.data.surah.name} — آية ${randomVerseData.data.numberInSurah}`);
      alert("Verse copied to clipboard. You can now paste it anywhere.");
    }
  };

  const handleDownloadImage = () => {
    const verseElement = document.getElementById('verseImage');
    html2canvas(verseElement, {
      backgroundColor: '#121212', // force solid black background
      useCORS: true
    }).then((canvas) => {
      const link = document.createElement('a');
      link.download = 'verse.jpg';
      link.href = canvas.toDataURL('image/jpeg', 1.0);
      link.click();
    });
  };


  return (
    <div>
      {!loading && randomVerseData ? (
        <div>
          <div className="verse-container text-center" id="verseImage">
            <h1>{randomVerseData.data.text}</h1>
            <p style={{ fontSize: '1.3rem' }}>
              {randomVerseData.data.surah.name} — آية {randomVerseData.data.numberInSurah}
            </p>
          </div>

          <div className="text-center mt-4">
            <audio controls>
              <source src={randomVerseData.data.audio} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>

          <div className="text-center mt-4">
            <button className="btn btn-light btn-lg shadow" onClick={fetchRandomVerse}>
              Random Verse
            </button>
          </div>

          <div className="text-center mt-4 d-flex justify-content-center gap-3">
            <button className="btn btn-outline-light" onClick={handleShare} title="Share Verse Text">
              <FaShareAlt />
            </button>
            <button className="btn btn-outline-light" onClick={handleDownloadImage} title="Download Verse as Image">
              <FaDownload />
            </button>
          </div>

        </div>

      ) : (
        <div className="loading-container">
          <img src="/loading-verse.gif" alt="Loading" />
        </div>
      )}
    </div>
  );
};

export default RandomVerse;
